<main class="search-page">
  <section class="search-hero">
    <div class="search-hero__content">
      <p class="eyebrow">Los Angeles County Assessor</p>
      <h1>How can we help?</h1>
      <p class="search-hero__intro">Search assessor services, property information, forms, and answers.</p>

      <form class="search-form" (ngSubmit)="submit()" role="search">
        <label class="visually-hidden" for="site-search">Search the assessor website</label>
        <span class="search-form__icon fas fa-search" aria-hidden="true"></span>
        <input id="site-search" name="query" type="search" [ngModel]="searchText()"
          (ngModelChange)="updateSearchText($event)" placeholder="Search for a topic or service" autocomplete="off" />
        @if (searchText()) {
          <button type="button" class="search-form__clear" (click)="clear()" aria-label="Clear search">&times;</button>
        }
        <button class="search-form__submit" type="submit">Search</button>
      </form>
    </div>
  </section>

  <section class="results" aria-live="polite">
    @if (submittedQuery() && searchQuery.isPending()) {
      <div class="results__status"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span> Searching...</div>
    } @else if (searchQuery.isError()) {
      <div class="results__empty"><h2>Search unavailable</h2><p>We could not complete that search. Please try again.</p></div>
    } @else if (!submittedQuery()) {
      <div class="results__empty results__empty--welcome">
        <div class="results__mark"><i class="fas fa-compass" aria-hidden="true"></i></div>
        <h2>Explore assessor resources</h2>
        <p>Try searching for “homeowners exemption”, “property tax”, or “change of ownership”.</p>
      </div>
    } @else if (results().length === 0) {
      <div class="results__empty"><h2>No results for “{{ submittedQuery() }}”</h2><p>Try a different phrase or use fewer words.</p></div>
    } @else {
      <div class="results__header"><p>Results for <strong>“{{ submittedQuery() }}”</strong></p><span>{{ results().length }} matches</span></div>
      <div class="result-list">
        @for (result of results(); track result.url + result.title) {
          <article class="result-card">
            <div class="result-card__number">{{ $index + 1 | number: '2.0-0' }}</div>
            <div class="result-card__body">
<!--              <a class="result-card__title" [href]="result.url" [routerLink]="result.url?.startsWith('/') ? result.url : null" target="_blank" rel="noopener">{{ result.title }}</a>-->
<!--              <p class="result-card__url">{{ result.url }}</p>-->
              @if (result.snippet) { <p class="result-card__snippet" [innerHTML]="result.snippet"></p> }
              <a [href]="result.url" target="_blank" rel="noopener">{{ result.url }}</a>
            </div>
            <a [href]="result.url" target="_blank" rel="noopener" [attr.aria-label]="'Open ' + result.title">
              <i class="fas fa-arrow-up-right-from-square result-card__arrow" aria-hidden="true"></i>
            </a>
          </article>
        }
      </div>
    }
  </section>
</main>
